// extracted by mini-css-extract-plugin
export default {"section":"UhROW4","container":"viFjSA","cta":"q3KpUA","mobileLottie":"LWyxNT","desktopLottie":"en5yAp","heading":"wtXzks"};